module.exports = __webpack_public_path__ + "static/media/icon6u.37fb383a.svg";